
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"79","height":"79"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Rectángulo 27","fill":"none","d":"M0 0h79v79H0z"}}),_c('path',{attrs:{"d":"M60.7 36.759L55.059 22.92h3.46v-3.46h-17.3V16h-3.46v3.46H20.46v3.46h3.46l-5.6 13.839H17v3.46h.519a8.2 8.2 0 003.114 4.256 8.546 8.546 0 0010.034 0 8.442 8.442 0 003.148-4.256h.485v-3.46h-1.558L26.964 22.92h10.795V50.6h-6.92l-1.349.623-6.92 8.683 1.349 2.8h31.14l1.349-2.8-6.92-8.684-1.349-.622h-6.92V22.92h10.83l-5.778 13.839h-1.592v3.46h.521a8.58 8.58 0 0016.3 0h.484v-3.46zm-32.559 5.225a5.259 5.259 0 01-2.491.657 5.017 5.017 0 01-2.457-.657 5.086 5.086 0 01-1.868-1.765h8.65a5.259 5.259 0 01-1.834 1.765zm.865-5.224h-6.92l3.46-8.3zm18.3 17.3l4.29 5.19H27.38l4.29-5.19zm6.159-25.534l3.46 8.3h-6.92zm2.355 13.527a4.878 4.878 0 01-2.491.657 4.671 4.671 0 01-2.457-.657A5.363 5.363 0 0149 40.219h8.65a4.74 4.74 0 01-1.83 1.834z","fill":"#6c757d"}})])
          )
        }
      }
    